import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import OButton from 'components/reusable/OButton'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import dayjs from 'dayjs'
import Pagination from '../Pagination'
import AuthContext from 'context/AuthContext'
import { useTranslation } from 'react-i18next'
import FinalOfferTable from './FinalOfferTable'
import OfferView from './OfferView'
import helpers from '../../utils/helpers'
import OSearch from 'components/reusable/OSearch'
import CustomSelect from 'components/reusable/CustomSelect'
import { offerLetterOptions } from 'utils/constants'

const EmployeeOfferLetter = () => {
  const { updatePageName } = useContext(AuthContext)
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [offerList, setOfferList] = useState([])
  const [currentItem, setCurrentItem] = useState('')
  const [offerView, setOfferView] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [isInitialized, setIsInitialized] = useState(false)
  const [filterData, setFilterData] = useState({
    category: '',
    searchKey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })
  const [sort, setSort] = useState({
    sortBy: 'offerSentDate',
    sortType: 'desc'
  })

  const handleView = item => {
    setCurrentItem(item)
    setOfferView(!offerView)
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const allOfferList = async data => {
    try {
      const { category, startDate, endDate, searchKey, isFilter } = filterData
      if (
        (data?.deletePage && offerList?.length >= 1) ||
        (isFilter && category && data?.statusChange && offerList?.length >= 1)
      ) {
        setPage(page - 1)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      }

      const payload = {
        page,
        pageSize,
        offerLetterStatus: category,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        ),
        keyword: searchKey?.trim(),
        sortBy: sort.sortBy,
        sortType: sort.sortType
      }
      const path = apiPath.offerList
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setOfferList(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(resultStatus, response.page, null),
        pageCount: helpers?.ternaryCondition(
          resultStatus,
          response.totalPages,
          null
        ),
        perPageItem: helpers?.ternaryCondition(
          resultStatus,
          response?.docs.length,
          null
        ),
        totalItems: helpers?.ternaryCondition(
          resultStatus,
          response.totalDocs,
          null
        )
      })
    } catch (error) {
      console.log('error in get all offer list==>>>>', error.message)
    }
  }

  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true)
    } else if (searchTerm || !filterData?.isReset) {
      setFilterData({
        ...filterData,
        isReset: false,
        searchKey: helpers?.ternaryCondition(
          debouncedSearchTerm,
          debouncedSearchTerm,
          ''
        ),
        isFilter: helpers?.ternaryCondition(debouncedSearchTerm, true, false)
      })
      setPage(1)
    }
  }, [debouncedSearchTerm])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  useEffect(() => {
    updatePageName(t('OFFER_LETTER_LIST'))
  }, [])

  useEffect(() => {
    allOfferList()
  }, [page, filterData, sort])

  const handleResetData = () => {
    setFilterData({
      category: '',
      searchKey: '',
      startDate: '',
      endDate: '',
      isReset: true,
      isFilter: false
    })
    setPage(1)
    setSearchTerm('')
  }

  const handleDateChangeData = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
  }

  const statusPage = e => {
    setFilterData({ ...filterData, category: e.target.value, isFilter: true })
    setPage(1)
  }

  return (
    <>
      {' '}
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3'>
              <div className='col-span-2 flex flex-wrap  items-center mb-2 2xl:mb-0'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap '>
                  <div className='relative flex items-center mb-3'>
                    <OSearch
                      searchTerm={searchTerm}
                      setSearchTerm={setSearchTerm}
                      placeholder={t('SEARCH_BY_EMPLOYEE_NAME')}
                    />
                  </div>
                  <ODateRangePicker
                    handleDateChange={handleDateChangeData}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  />
                  <CustomSelect
                    id='category'
                    name='category'
                    value={filterData.category}
                    onChange={statusPage}
                    options={offerLetterOptions}
                    placeholder='O_ALL'
                    t={t}
                  />
                  <OButton
                    label='Reset'
                    type='button'
                    onClick={handleResetData}
                    extraClasses='ml-3 mb-3'
                    style={{ borderRadius: '0.5rem' }}
                  />
                </div>
              </div>
            </form>
            <FinalOfferTable
              offerList={offerList}
              allOfferList={allOfferList}
              page={page}
              handleView={handleView}
              currentItem={currentItem}
              offerView={offerView}
              setSort={setSort}
              sort={sort}
            />
            {offerView && (
              <OfferView
                offerView={offerView}
                setOfferView={setOfferView}
                currentItem={currentItem}
                handleView={handleView}
              />
            )}
            {helpers.ternaryCondition(
              paginationObj?.totalItems,
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />,
              null
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default EmployeeOfferLetter
